import { defineMessages } from 'react-intl';

export default defineMessages({
  searchTitle: {
    id: 'view.appBar.search.title',
    defaultMessage: 'Search',
  },
  searchPlaceholder: {
    id: 'view.search.newui.placeholder',
    defaultMessage: 'Search ...',
  },
  clearSearch: {
    id: 'view.appBar.search.clear',
    defaultMessage: 'Clear search',
  },
});
